import { useEffect } from 'react';
import { Link } from 'react-router';
import { platform } from '../lib/api';
import { setAppTitle } from '../lib/format';
import { UserStatusChip, useLoad } from './common';

export function SellersPage() {
  const { data, error } = useLoad(() => platform.sellers());
  useEffect(() => setAppTitle('Sellers'), []);

  return (
    <main className="page wide pa-page">
      <header className="pa-head">
        <h1>Sellers</h1>
        <Link className="btn primary" to="/platform-admin/sellers/new">New seller</Link>
      </header>
      {error && <p className="error" role="alert">{error}</p>}
      {!data ? (
        !error && <p className="muted">Loading…</p>
      ) : (
        <ul className="pa-list">
          {data.sellers.map((s) => (
            <li key={s.id}>
              <Link className="pa-row" to={`/platform-admin/sellers/${s.id}`}>
                <span className="pa-row-main">
                  <strong>{s.displayName}{s.role === 'PLATFORM_ADMIN' && <span className="muted small"> · admin</span>}</strong>
                  <span className="muted small">{s.email}</span>
                </span>
                <span className="pa-row-meta">
                  <span className="muted small">{s.sales.length} sale{s.sales.length === 1 ? '' : 's'}</span>
                  <UserStatusChip status={s.status} hasPassword={s.hasPassword} />
                </span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </main>
  );
}
